import React from 'react';
import {
  Theme,
  seismicTheme,
  Button,
  ButtonMenuContainer,
  ButtonMenuTrigger,
  ButtonMenuMenu,
  ButtonMenuItem,
  IconMore,
  IconNews,
} from '@seismic/mantle';
import VideoDownloadButton from 'components/shared/UniversalDownloadButton/VideoDownloadButton';

export default function RecordingMenuContainer({
  mediaShareLink,
  isAdmin,
  hasChannelLearningIntegrationEnabled,
  thinModel,
}) {
  return (
    <div className="RecordingMenuContainer mt-16 d-f">
      <Theme
        theme={seismicTheme({
          useGlobal: true,
        })}
      >
        <ButtonMenuContainer>
          <ButtonMenuTrigger>
            <Button
              startAdornment={IconMore}
              label={t('common.open_menu')}
              variant="ghost"
              hideLabel
            />
          </ButtonMenuTrigger>
          <ButtonMenuMenu>
            {hasChannelLearningIntegrationEnabled && (
              <ButtonMenuItem startAdornment={IconNews}>
                {t('common.post_to_channels')}
              </ButtonMenuItem>
            )}
            {isAdmin && (
              <VideoDownloadButton
                item={thinModel}
                componentAs={ButtonMenuItem}
              />
            )}
          </ButtonMenuMenu>
        </ButtonMenuContainer>
      </Theme>
      <div className="w-100p h-32">
        <input
          className="RecordingMenuContainer-linkInput h-32 w-100p fz-sm"
          defaultValue={mediaShareLink}
          aria-label={t('common.copy_link')}
          data-behavior="highlight_on_focus"
          readOnly
        />
      </div>
    </div>
  );
}
